import { api, sessionToUser, client } from '@/shared/api/generated'
import type { LoginResult, SessionResponse, VerifyTOTPResponse, User } from '@/shared/api/generated'

export const authApi = {
  login: (username: string, password: string): Promise<LoginResult> =>
    api.login({ username, password }),

  verify2FA: async (tempToken: string, code: string): Promise<{ token: string; user: User }> => {
    const { data } = await client.post<VerifyTOTPResponse>(
      '/2fa/verify', { code },
      { headers: { Authorization: `Bearer ${tempToken}` } },
    )
    const { data: session } = await client.get<SessionResponse>(
      '/session',
      { headers: { Authorization: `Bearer ${data.token}` } },
    )
    return { token: data.token, user: sessionToUser(session) }
  },

  logout: api.logout,
  getSession: api.getSession,
  sessionToUser,
}
